import abbreviateNames from "~/filters/abbreviateNames";
import compactString from "~/filters/compactString";
import formatBoolean from "~/filters/formatBoolean";
import formatBytes from "~/filters/formatBytes";
import formatCpr from "~/filters/formatCpr";
import formatDate from "~/filters/formatDate";
import formatDateTime from "~/filters/formatDateTime";
import formatDateWithDay from "~/filters/formatDateWithDay";
import formatMinutes from "~/filters/formatMinutes";
import formatMonth from "~/filters/formatMonth";
import formatNumber from "~/filters/formatNumber";
import formatPhoneNumber from "~/filters/formatPhoneNumber";
import formatPrice from "~/filters/formatPrice";
import formatText from "~/filters/formatText";
import formatTime from "~/filters/formatTime";
import formatTimeSpan from "~/filters/formatTimeSpan";
import formatTimeago from "~/filters/formatTimeago";

export const filters = {
  install(app) {
    app.config.globalProperties.$filters = {
      abbreviateNames,
      compactString,
      formatBoolean,
      formatBytes,
      formatCpr,
      formatDate,
      formatDateTime,
      formatDateWithDay,
      formatMinutes,
      formatMonth,
      formatNumber,
      formatPhoneNumber,
      formatPrice,
      formatText,
      formatTime,
      formatTimeago,
      formatTimeSpan,
    };
  },
};
